interface EmailBuilderParams {
	salutation: string;
	toName: string;
	start: string;
	end: string;
	from: string;
	diaryId?: string;
	patientId?: string;
}

export function buildEmail(props: EmailBuilderParams) {
	return `${props.salutation} ${props.toName},

${props.start ?? ""}

${props.end ?? ""}

${props.from}`;
}

// Keep the hook for backward compatibility
export function useEmailBuilder(props: EmailBuilderParams) {
	return `${props.salutation} ${props.toName},

${props.start ?? ""}

${props.end ?? ""}

${props.from}`;
}
